import { HStack, VStack } from "@gluestack-ui/themed";
import { ReportCardProps } from "../../types";
import { Text } from "@repo/core/components/core/Text";
import { MustShow } from "@repo/core/components/core/MustShow";
import { ReportCardEnum } from "@repo/core/types/reports";

export const MonthlyTransactionCard = ({
  period,
  total,
  bgColor = "$backgroundLight100",
  values,
  propsByVariant
}: ReportCardProps) => {
  const variantProps =
    propsByVariant as (typeof propsByVariant)[ReportCardEnum.MONTHLY_TRANSACTIONS];
  if (!variantProps) return null;

  return (
    <VStack
      w="$full"
      p="$4"
      bgColor={bgColor}
      gap="$4"
      borderBottomWidth={1}
      borderColor="$borderLight100"
    >
      <Text color="$textLight600" fontSize="$sm" fontWeight={600}>
        {period}
      </Text>
      <MustShow isVisible={variantProps.showTotal}>
        <HStack alignItems="center" justifyContent="space-between">
          <Text
            color={total?.styles?.color}
            fontSize={total?.styles?.fontSize}
            fontWeight={total?.styles?.fontWeight}
          >
            {total?.label} {total?.value}
          </Text>
          <Text color="$textLight600" fontSize="$sm" fontWeight={500}>
            {variantProps.totalTransactions} transações
          </Text>
        </HStack>
      </MustShow>

      <VStack gap="$2">
        {values.map((value) => {
          return (
            <HStack alignItems="center" justifyContent="space-between">
              <Text color="$textLight600" fontSize="$sm" fontWeight={500}>
                {value.label}
              </Text>

              <Text color="$textLight600" fontSize="$sm" fontWeight={400}>
                {value.value}
              </Text>
            </HStack>
          );
        })}
      </VStack>
    </VStack>
  );
};
